<template>
  <v-app-bar :height="appBarHeight" color="white" elevation="0" app>
    <router-link to="/" class="header-title">NOBUAKI HONDA</router-link>
    <v-spacer></v-spacer>
    <nav class="pc_area" aria-label="メインナビゲーション">
      <ul
        itemscope
        itemtype="http://www.schema.org/SiteNavigationElement"
        class="d-flex align-center pa-0"
        role="list"
      >
        <template v-for="(menu, i) in menus">
          <li v-if="i !== 0" :key="i" itemprop="name">
            <router-link
              :to="menu.href"
              itemprop="url"
              class="header-menu"
              :class="{ 'router-link-active': isScheduleMenuActive(menu) }"
            >
              {{ menu.name }}
            </router-link>
          </li>
        </template>
        <li itemprop="name">
          <a
            href="https://www.youtube.com/channel/UCFfB_K0HHo4zl9hcjG6_pyw"
            target="_blank"
            rel="noopener noreferrer"
            class="mx-auto"
            aria-label="本多信明のYouTubeチャンネルを開く"
          >
            <i class="icon-youtube fab fa-youtube"></i>
          </a>
        </li>
        <li itemprop="name">
          <a
            href="https://www.instagram.com/tenorenobuakihonda"
            target="_blank"
            rel="noopener noreferrer"
            class="mx-auto"
            aria-label="本多信明のInstagramを開く"
          >
            <i class="icon-instagram fab fa-instagram"></i>
          </a>
        </li>
      </ul>
    </nav>

    <!--ハンバーガーメニューのボタン-->
    <button
      ref="menuButton"
      type="button"
      class="hamburger_btn phone_area"
      :class="{ 'hamburger_btn--open': showMenu }"
      :aria-expanded="showMenu ? 'true' : 'false'"
      aria-controls="mobile-navigation"
      :aria-label="showMenu ? 'メニューを閉じる' : 'メニューを開く'"
      @click="toggleMenu"
    >
      <span class="line line_01" v-bind:class="{ btn_line01: showMenu }"></span>
      <span class="line line_02" v-bind:class="{ btn_line02: showMenu }"></span>
      <span class="line line_03" v-bind:class="{ btn_line03: showMenu }"></span>
    </button>
    <!--サイドバー-->
    <nav
      ref="mobileNavigation"
      id="mobile-navigation"
      class="menu phone_area"
      :class="{
        'menu--open': panelOpen,
        'menu--items-visible': menuItemsVisible,
      }"
      :aria-hidden="menuItemsVisible ? 'false' : 'true'"
      :inert="menuItemsVisible ? null : 'inert'"
      aria-label="モバイルナビゲーション"
      @transitionend="handleMenuTransitionEnd"
      @transitioncancel="handleMenuTransitionCancel"
    >
      <div ref="mobileMenuScroll" class="menu__scroll px-8">
        <ul class="mobile-menu ma-6 pa-0" role="list">
          <li
            v-for="(menu, menuIndex) in menus"
            :key="menu.href"
            class="mobile-menu__item"
            :style="mobileMenuMotionStyle(menuIndex)"
          >
            <router-link
              ref="mobileLinks"
              :to="menu.href"
              class="mobile-menu__link px-8 py-5"
              :class="{ 'router-link-active': isScheduleMenuActive(menu) }"
              :tabindex="menuItemsVisible ? null : -1"
              @click.native="closeMenu"
            >
              <span class="mobile-menu__label">{{ menu.name }}</span>
            </router-link>
          </li>
          <li
            class="mobile-menu__item mobile-menu__social"
            :style="mobileMenuMotionStyle(menus.length)"
          >
            <a
              href="https://www.youtube.com/channel/UCFfB_K0HHo4zl9hcjG6_pyw"
              target="_blank"
              rel="noopener noreferrer"
              class="mobile-menu__social-link"
              aria-label="本多信明のYouTubeチャンネルを開く"
              :tabindex="menuItemsVisible ? null : -1"
              @click="closeMenu"
            >
              <span class="mobile-menu__icon" aria-hidden="true">
                <!-- Font Awesome Free 5.6.1, CC BY 4.0 -->
                <svg
                  class="mobile-menu__youtube-icon"
                  viewBox="0 0 576 512"
                  focusable="false"
                >
                  <path
                    fill="currentColor"
                    d="M549.655 124.083c-6.281-23.65-24.787-42.276-48.284-48.597C458.781 64 288 64 288 64S117.22 64 74.629 75.486c-23.497 6.322-42.003 24.947-48.284 48.597-11.412 42.867-11.412 132.305-11.412 132.305s0 89.438 11.412 132.305c6.281 23.65 24.787 41.5 48.284 47.821C117.22 448 288 448 288 448s170.78 0 213.371-11.486c23.497-6.321 42.003-24.171 48.284-47.821 11.412-42.867 11.412-132.305 11.412-132.305s0-89.438-11.412-132.305zm-317.51 213.508V175.185l142.739 81.205-142.739 81.201z"
                  />
                </svg>
              </span>
            </a>
          </li>
          <li
            class="mobile-menu__item mobile-menu__social"
            :style="mobileMenuMotionStyle(menus.length + 1)"
          >
            <a
              href="https://www.instagram.com/tenorenobuakihonda"
              target="_blank"
              rel="noopener noreferrer"
              class="mobile-menu__social-link"
              aria-label="本多信明のInstagramを開く"
              :tabindex="menuItemsVisible ? null : -1"
              @click="closeMenu"
            >
              <span class="mobile-menu__icon" aria-hidden="true">
                <i class="y fab fa-instagram"></i>
              </span>
            </a>
          </li>
        </ul>
      </div>
    </nav>
  </v-app-bar>
</template>

<script>
import { SCHEDULE_CANONICAL_PATH } from "../config/scheduleArchive";

const MENU_OPEN_FALLBACK_MS = 800;
const MENU_CLOSE_FALLBACK_MS = 460;

export default {
  name: "AppHeader",
  props: {
    appBarHeight: {
      type: Number,
      required: true,
    },
  },
  data: () => ({
    showMenu: false,
    panelOpen: false,
    menuItemsVisible: false,
    menus: [
      { name: "HOME", href: "/" },
      { name: "NEWS", href: "/news" },
      { name: "SCHEDULE", href: SCHEDULE_CANONICAL_PATH },
      { name: "PROFILE", href: "/profile" },
      { name: "MUSIC", href: "/music" },
      { name: "VIDEOS", href: "/videos" },
      { name: "CONTACT", href: "/contact" },
    ],
  }),
  created() {
    this.menuOpenFrame = null;
    this.menuTransitionTimer = null;
    this.pageScrollState = null;
  },
  methods: {
    isScheduleMenuActive(menu) {
      return (
        menu.href === SCHEDULE_CANONICAL_PATH &&
        Number.isInteger(this.$route.meta.scheduleYear)
      );
    },
    mobileMenuMotionStyle(index) {
      return {
        "--mobile-menu-enter-delay": `${index * 24}ms`,
      };
    },
    prefersReducedMotion() {
      return (
        typeof window !== "undefined" &&
        typeof window.matchMedia === "function" &&
        window.matchMedia("(prefers-reduced-motion: reduce)").matches
      );
    },
    cancelScheduledMenuOpen() {
      if (
        this.menuOpenFrame !== null &&
        typeof window !== "undefined" &&
        typeof window.cancelAnimationFrame === "function"
      ) {
        window.cancelAnimationFrame(this.menuOpenFrame);
      }
      this.menuOpenFrame = null;
    },
    clearMenuTransitionFallback() {
      if (this.menuTransitionTimer !== null) {
        window.clearTimeout(this.menuTransitionTimer);
        this.menuTransitionTimer = null;
      }
    },
    scheduleMenuTransitionFallback(delay) {
      this.clearMenuTransitionFallback();
      this.menuTransitionTimer = window.setTimeout(() => {
        this.menuTransitionTimer = null;
        this.completeMenuTransition();
      }, delay);
    },
    openMenu() {
      if (this.showMenu) {
        return;
      }

      this.cancelScheduledMenuOpen();
      this.clearMenuTransitionFallback();
      this.showMenu = true;
      this.menuItemsVisible = false;
      if (this.$refs.mobileMenuScroll) {
        this.$refs.mobileMenuScroll.scrollTop = 0;
      }
      this.setPageScrollLocked(true);

      if (this.prefersReducedMotion()) {
        this.panelOpen = true;
        this.menuItemsVisible = true;
        this.$nextTick(this.focusFirstMobileLink);
        return;
      }

      if (
        typeof window === "undefined" ||
        typeof window.requestAnimationFrame !== "function"
      ) {
        this.panelOpen = true;
        this.scheduleMenuTransitionFallback(MENU_OPEN_FALLBACK_MS);
        return;
      }

      this.menuOpenFrame = window.requestAnimationFrame(() => {
        this.menuOpenFrame = null;
        if (this.showMenu) {
          this.panelOpen = true;
          this.scheduleMenuTransitionFallback(MENU_OPEN_FALLBACK_MS);
        }
      });
    },
    closeMenu() {
      const wasPanelOpen = this.panelOpen;
      this.cancelScheduledMenuOpen();
      this.clearMenuTransitionFallback();
      this.showMenu = false;
      this.menuItemsVisible = false;
      this.panelOpen = false;

      if (!wasPanelOpen || this.prefersReducedMotion()) {
        this.$nextTick(() => this.setPageScrollLocked(false));
      } else {
        this.scheduleMenuTransitionFallback(MENU_CLOSE_FALLBACK_MS);
      }
    },
    toggleMenu() {
      if (this.showMenu) {
        this.closeMenu();
      } else {
        this.openMenu();
      }
    },
    isMenuTransformTransition(event) {
      return (
        event.target === this.$refs.mobileNavigation &&
        event.propertyName === "transform"
      );
    },
    completeMenuTransition() {
      this.clearMenuTransitionFallback();

      if (this.panelOpen && this.showMenu) {
        this.menuItemsVisible = true;
        this.$nextTick(this.focusFirstMobileLink);
      } else if (!this.showMenu) {
        this.setPageScrollLocked(false);
      }
    },
    handleMenuTransitionEnd(event) {
      if (!this.isMenuTransformTransition(event)) {
        return;
      }

      this.completeMenuTransition();
    },
    handleMenuTransitionCancel(event) {
      if (!this.isMenuTransformTransition(event)) {
        return;
      }

      this.scheduleMenuTransitionFallback(
        this.showMenu ? MENU_OPEN_FALLBACK_MS : MENU_CLOSE_FALLBACK_MS
      );
    },
    setPageScrollLocked(isLocked) {
      if (typeof document === "undefined") {
        return;
      }

      const root = document.documentElement;
      const body = document.body;

      if (isLocked && !this.pageScrollState) {
        this.pageScrollState = {
          rootOverflow: root.style.overflow,
          bodyOverflow: body.style.overflow,
        };
        root.style.overflow = "hidden";
        body.style.overflow = "hidden";
      } else if (!isLocked && this.pageScrollState) {
        root.style.overflow = this.pageScrollState.rootOverflow;
        body.style.overflow = this.pageScrollState.bodyOverflow;
        this.pageScrollState = null;
      }
    },
    focusFirstMobileLink() {
      const links = this.$refs.mobileLinks;
      const firstLink = Array.isArray(links) ? links[0] : links;
      if (firstLink && firstLink.$el) {
        firstLink.$el.focus();
      }
    },
    handleEscape() {
      if (!this.showMenu) {
        return;
      }

      this.closeMenu();
      this.$nextTick(() => {
        if (this.$refs.menuButton) {
          this.$refs.menuButton.focus();
        }
      });
    },
    handleDocumentKeydown(event) {
      if (!this.showMenu) {
        return;
      }

      if (event.key === "Escape" || event.key === "Esc") {
        event.preventDefault();
        this.handleEscape();
        return;
      }

      if (event.key !== "Tab") {
        return;
      }

      const navigation = this.$refs.mobileNavigation;
      const menuButton = this.$refs.menuButton;
      const links = navigation
        ? Array.from(
            navigation.querySelectorAll('a[href]:not([tabindex="-1"])')
          )
        : [];
      const focusableElements = [menuButton, ...links].filter(Boolean);

      if (!focusableElements.length) {
        return;
      }

      const firstElement = focusableElements[0];
      const lastElement = focusableElements[focusableElements.length - 1];
      const activeElement = document.activeElement;

      if (event.shiftKey && activeElement === firstElement) {
        event.preventDefault();
        lastElement.focus();
      } else if (!event.shiftKey && activeElement === lastElement) {
        event.preventDefault();
        firstElement.focus();
      } else if (!focusableElements.includes(activeElement)) {
        event.preventDefault();
        firstElement.focus();
      }
    },
    handleResize() {
      if (!this.showMenu || window.innerWidth <= 868) {
        return;
      }

      this.closeMenu();
      this.setPageScrollLocked(false);
      const mainContent = document.getElementById("main-content");
      if (mainContent) {
        try {
          mainContent.focus({ preventScroll: true });
        } catch (error) {
          mainContent.focus();
        }
      }
    },
  },
  watch: {
    $route() {
      this.closeMenu();
    },
  },
  mounted() {
    document.addEventListener("keydown", this.handleDocumentKeydown);
    window.addEventListener("resize", this.handleResize);
  },
  beforeDestroy() {
    this.cancelScheduledMenuOpen();
    this.clearMenuTransitionFallback();
    this.setPageScrollLocked(false);
    document.removeEventListener("keydown", this.handleDocumentKeydown);
    window.removeEventListener("resize", this.handleResize);
  },
};
</script>

<style lang="scss" scoped>
@use "../assets/sass/variables" as v;
.header-title {
  color: v.$header-title-color;
  letter-spacing: 0.025em;
  font-family: v.$title-font;
  font-size: v.$xl-font;
  font-weight: 400;
  white-space: nowrap;
}

.header-menu {
  color: v.$sub-color;
  letter-spacing: 0.01em;
  font-family: v.$title-font;
  font-size: v.$sm-font;
  font-weight: 400;
  margin: 0.85rem;
  &.router-link-active {
    font-weight: bold;
  }
}

.icon {
  &-youtube {
    color: rgba(255, 1, 2);
    font-size: 1.8em;
    margin: 1rem;
  }
  &-instagram {
    background: linear-gradient(
      45deg,
      #f09433,
      #e6683c,
      #dc2743,
      #cc2366,
      #bc1888
    );
    background-clip: text;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    color: transparent;
    font-size: 1.8em;
    margin: 1rem;
  }
}

.pc_area {
  display: block;
  ul {
    list-style: none;
  }
}
.phone_area {
  display: none;
}

// スマホ
@media screen and (max-width: 868px) {
  .pc_area {
    display: none;
  }
  .phone_area {
    display: block;
  }
  .hamburger_btn {
    padding: 0;
    border: 0;
    background: transparent;
    position: fixed;
    top: 0;
    right: 0;
    width: 70px;
    height: var(--site-app-bar-height, 56px);
    cursor: pointer;
    z-index: 50;
    -webkit-tap-highlight-color: transparent;
    .line {
      position: absolute;
      top: 0;
      left: 20px;
      width: 32px;
      height: 1px;
      background: rgba(69, 54, 38, 0.9);
      text-align: center;
      transform-origin: center;
      backface-visibility: hidden;
      transition-property: transform, opacity, background-color;
      transition-duration: 0.28s, 0.12s, 0.18s;
      transition-timing-function: cubic-bezier(0.3, 0.55, 0.45, 1), ease-out,
        ease-out;
    }
    .line_01 {
      top: calc(50% - 10px);
    }
    .line_02 {
      top: 50%;
    }
    .line_03 {
      top: calc(50% + 10px);
    }
    .btn_line01 {
      background-color: white;
    }
    .btn_line03 {
      background-color: white;
    }
    &--open .line {
      transition-duration: 0.36s, 0.14s, 0.2s;
      transition-timing-function: cubic-bezier(0.22, 1, 0.36, 1), ease,
        ease;
    }
  }

  .btn_line01 {
    transform: translateY(10px) rotate(-45deg);
  }
  .btn_line02 {
    opacity: 0;
  }
  .btn_line03 {
    transform: translateY(-10px) rotate(45deg);
  }

  .menu {
    background-color: rgba(155, 129, 90, 1);
    position: fixed;
    top: 0;
    right: 0;
    z-index: 30;
    font-size: 5rem;
    letter-spacing: 0.3em;
    max-width: 100vw;
    pointer-events: none;
    transform: translate3d(0, calc(-100% - 1px), 0);
    transition: transform 0.36s cubic-bezier(0.3, 0.55, 0.45, 1);
    will-change: transform;
    contain: paint;
    isolation: isolate;
    backface-visibility: hidden;
  }

  .menu--open {
    transform: translate3d(0, 0, 0);
    transition-duration: 0.3s;
    transition-timing-function: cubic-bezier(0.34, 0.34, 0.5, 1);
  }

  .menu--items-visible {
    pointer-events: auto;
  }

  .menu__scroll {
    box-sizing: border-box;
    width: 100%;
    padding: 2rem 1rem;
    overflow-x: hidden;
    overflow-y: auto;
    max-height: 100vh;
    max-height: 100dvh;
    overscroll-behavior-y: contain;
    -webkit-overflow-scrolling: touch;
  }

  .mobile-menu {
    padding: 8px 0 !important;
    list-style: none;
  }

  .mobile-menu__item {
    border-bottom: white solid 1px;
    font-family: v.$title-font;
    opacity: 0;
    transform: translate3d(0, 0, 0);
    transition: opacity 0.1s ease-in;
  }

  .menu--open:not(.menu--items-visible) .mobile-menu__item {
    transform: translate3d(0, 10px, 0);
  }

  .menu--items-visible .mobile-menu__item {
    opacity: 1;
    transform: translate3d(0, 0, 0);
    transition-property: transform, opacity;
    transition-duration: 0.3s, 0.24s;
    transition-timing-function: cubic-bezier(0.16, 1, 0.3, 1), ease-out;
    transition-delay: var(--mobile-menu-enter-delay);
  }

  .mobile-menu__label {
    display: inline-block;
  }

  .mobile-menu__link,
  .mobile-menu__social-link {
    color: white;
    display: block;
    font-size: v.$lg-font;
    letter-spacing: 0.4rem;
    text-align: center;
  }

  .mobile-menu__link {
    display: flex;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
    height: 72px;
    padding: 0 48px !important;
  }

  .mobile-menu__link:focus-visible,
  .mobile-menu__social-link:focus-visible {
    outline: 3px solid white;
    outline-offset: -5px;
  }

  .hamburger_btn:focus-visible {
    outline: 3px solid #211c1a;
    outline-offset: -6px;
    box-shadow: inset 0 0 0 9px white;
  }

  .hamburger_btn--open:focus-visible {
    outline-color: white;
    box-shadow: inset 0 0 0 9px #211c1a;
  }

  .mobile-menu__social-link {
    display: flex;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
    height: 70px;
    padding: 0;
  }

  .mobile-menu__icon {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .y {
    flex: none;
    color: white;
    font-size: 4rem;
    transform: translateY(2px);
  }

  .mobile-menu__youtube-icon {
    flex: none;
    width: 1.125em;
    height: 1em;
    color: white;
    font-size: 4rem;
    transform: translateY(2px);
  }

  .y.fa-instagram::before {
    background-color: white;
    background-image: none;
  }

  @media (prefers-reduced-motion: reduce) {
    .hamburger_btn .line {
      transition: none;
    }

    .menu,
    .mobile-menu__item {
      transition: none;
    }
  }
}
</style>
